// extracted by mini-css-extract-plugin
export default {"rating":"JG-z","numberOfStars":"KG-z","count":"LG-z","barGraphSpacing":"MG-z","barGraph":"NG-z"};